import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaInformacionOpEditar', {
    template: template,
    controller: NominasNominaInformacionOpEditarComponent,
    bindings: {
      idEmpresa: '<',
      idNomina: '<',
      acumulado: '<',
      calculado: '<',
      onChange: '&',
      onClose: '&',
    },
  })

function NominasNominaInformacionOpEditarComponent($q, $catalogos, NominasNominaInformacionOp) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.actualizar = actualizar
  $ctrl.filtrarCuentas = filtrarCuentas
  $ctrl.seleccionarEmpresa = seleccionarEmpresa

  function $onInit() {
    $ctrl.$promise = $q.all({
      op: NominasNominaInformacionOp.get($ctrl.idEmpresa, $ctrl.idNomina),
      clientes: $catalogos.get('clientes'),
      cuentasBancarias: $catalogos.get('cuentasBancarias'),
    }).then(function (resolve) {
      $ctrl.data = resolve.op.data
      $ctrl.clientes = resolve.clientes
      $ctrl.cuentasBancarias = resolve.cuentasBancarias
      filtrarCuentas()
    })
  }

  function actualizar() {
    $ctrl.actualizando = true

    NominasNominaInformacionOp.put($ctrl.idEmpresa, $ctrl.idNomina, $ctrl.data)
      .then(function (response) {
        $ctrl.onChange({$event: {data: response.data}})
      })
      .finally(function () {
        $ctrl.actualizando = false
      })
  }

  function filtrarCuentas() {
    $ctrl.cuentasMxn = $ctrl.cuentasBancarias.filter(function (item) {
      return item.ID_Cliente === $ctrl.data.id_cliente
        && item.ID_Moneda === '1'
    })
    $ctrl.cuentasUsd = $ctrl.cuentasBancarias.filter(function (item) {
      return item.ID_Cliente === $ctrl.data.id_cliente
        && item.ID_Moneda === '2'
    })
  }

  function seleccionarEmpresa() {
    $ctrl.data.id_cuenta_mxn = ''
    $ctrl.data.id_cuenta_usd = ''

    filtrarCuentas()
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/informacion/op/editar/component.js